import React, { useState, useCallback, useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard"
import QRCode from 'qrcode.react'

// Material-ui Components
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';

// Api and Helper functions
import { getLocalizedMessage } from './_helpers/Localization';
import { getLanguage } from './_helpers/HelperFunctions';
import { get } from "./_api/api";

// Pages
import Error from "./Error";
import Spinner from "./Spinner";

const useStyles = makeStyles(theme => ({

    spinner: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    share: {
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
        position: 'relative',
        width: '80%',
        display: 'flex',
        flexDirection: "column",
        alignItems: 'center',
    },

    logo: {
        paddingTop: '16px',
        paddingBottom: '16px'
    },

    qrcode: {
        width: '90%',
        display: 'flex',
    },

    text: {
        width: '90%',
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        paddingBottom: '16px',
    },

    link: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '16px',
        paddingTop: '16px',
        textAlign: 'center',
    },
    button: {
        width: '50%',
        display: 'flex'
    },

    app: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }
}));

export default function Share() {

    const classes = useStyles();
    const [data, setData] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [status, setStatus] = useState('');
    const hash = window.location.pathname.substr(1);

    const language = getLanguage();
    const Message = getLocalizedMessage('sharetext', language);

    const fetchData = useCallback(async () => {
        setFetching(true);
        get("/Enroll/share-pass/" + hash).then(response => {
            setData(response.data.Data);
            setStatus(response.status);
            setFetching(false);
        })
            .catch(error => { console.log(error); setStatus(404); setFetching(false) });
    }, [setData, hash]);

    useEffect(() => {
        fetchData();

    }, [fetchData]);

    if (fetching) return <div className={classes.spinner}><Spinner /></div>;

    else
        if (status === 404 || status === '')
            return <Error Language={language} />;

        else
            return (
                <div className={classes.app}>
                    <div className={classes.share}>
                        <img alt="Logo" src={data && data.LogoUrl} className={classes.logo} />
                        <Typography variant="body1" className={classes.text}>
                            {Message.MessageText1} {data && data.PassName} {Message.MessageText2}
                        </Typography>
                        <QRCode size={200} level={"M"} value={(data && data.EnrollUrl) || ''} className={classes.qrcode} />
                        <Link href={data && data.EnrollUrl} className={classes.link}>{data && data.EnrollUrl}</Link>
                         <CopyToClipboard text={data && data.EnrollUrl}>
                            <Button variant="contained" color="primary" className={classes.button}>
                                {Message.ButtonText}
                            </Button>
                        </CopyToClipboard>
                    </div>
                </div >
            );
}